import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {fetcher} from '#lit/utils/http.js';
import type {Auth0User} from '#lit/types/user.js';
import {RequestMethod} from '#lit/common/constants/index.js';

export const VERIFICATION_CHECKER_ELEMENT_TAG = 'verification-checker';
const VERIFICATION_ENDPOINT = '/api/users/verifications';
const VERIFICATION_TIMEOUT_MS = 5000;
const REDIRECT_DESTINATION = '/audiences';

interface VerificationResponse {
  data: {
    id: string;
    type: string;
    attributes: Auth0User;
  };
}

/**
 * VerificationChecker -- Ensures user has a verified email.
 */
@customElement(VERIFICATION_CHECKER_ELEMENT_TAG)
export default class VerificationChecker extends FlywheelComponent {
  pinger?: number;
  verified = false;

  static get styles() {
    return [styles];
  }

  load() {
    this.pinger = window.setInterval(
      this.verify.bind(this),
      VERIFICATION_TIMEOUT_MS
    );
  }

  async verify(): Promise<void> {
    try {
      const {data} = await fetcher<VerificationResponse>(
        VERIFICATION_ENDPOINT,
        {
          method: RequestMethod.GET,
        }
      );

      this.verified = data.attributes.email_verified;

      if (this.verified) {
        clearInterval(this.pinger);

        setTimeout(() => {
          location.href = REDIRECT_DESTINATION;
        }, VERIFICATION_TIMEOUT_MS);
      }

      this.requestUpdate();
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    if (this.verified) {
      return html`
        <h4>You are verified</h4>
        <p>we will be redirecting you in a few seconds.</p>
      `;
    }

    return html`
      <div class="verification-checker">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [VERIFICATION_CHECKER_ELEMENT_TAG]: VerificationChecker;
  }
}
